import { Lead, LeadCreationAction } from "@justhome/common/api/core";
import { Title } from "@justhome/react-ui";
import clsx from "clsx";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { FC } from "react";
import LeadWallForm, { LeadWallFormValue } from "./LeadWallForm";

interface LeadWallBudgetFirstStepProps {
  leadCreationAction?: LeadCreationAction;
  onPrevious: VoidFunction;
  defaultValues?: Partial<LeadWallFormValue>;
  isEmbedded?: boolean;
  onSubmit: (value: Lead) => void;
  isLoading: boolean;
  isError: boolean;
}
const LeadWallBudgetFirstStep: FC<LeadWallBudgetFirstStepProps> = ({
  onPrevious,
  defaultValues,
  isEmbedded = false,
  isLoading,
  isError,
  onSubmit,
}) => {
  const { t } = useTranslation("budget-check");

  return (
    <>
      <Title
        className={clsx(
          "text-h1",
          isEmbedded ? "mb-3m" : "mb-3s hidden m:block",
        )}
      >
        {t("lead_wall_title")}
      </Title>
      {!isEmbedded && (
        <>
          <ul className="hidden m:block text-body-1 list-disc pl-2s mb-m marker:text-primary-800 space-y-xs">
            <li>{t("lead_wall_list_1")}</li>
            <li>{t("lead_wall_list_2")}</li>
          </ul>
          <div className="m:hidden mb-m">
            <div className="hidden s:grid grid-cols-3 gap w-auto bg-primary-50 bg-pattern-7-dark border-primary-800 p-s rounded-s border border-opacity-10h-[288px]">
              <div className="block col-span-1 h-full w-full relative">
                <Image
                  alt=""
                  fill
                  src="https://cdn.justhome.com/cdn/assets/result_preview_f9eeb3125d.png"
                  className="object-contain"
                />
              </div>
              <div className="flex items-center s:block col-span-2">
                <Title className="text-h2 mb-3s">{t("lead_wall_title")}</Title>
                <ul className="block text-h4 text-neutral-425 list-disc marker:text-primary-800 pl-2s space-y-2xs">
                  <li>{t("lead_wall_list_1")}</li>
                  <li>{t("lead_wall_list_2")}</li>
                </ul>
              </div>
            </div>
            <Title className="s:hidden text-h2 mb-3s">
              {t("lead_wall_title")}
            </Title>
          </div>
        </>
      )}
      <LeadWallForm
        isError={isError}
        isLoading={isLoading}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        onPrevious={onPrevious}
        isEmbedded={isEmbedded}
      />
    </>
  );
};

export default LeadWallBudgetFirstStep;
